import { Vector2 } from "../../common/vector2.js";
import { ImgID } from "../../image_loader/img_id.js";
import { Easing } from "../../transforms/transform_base.js";
import { TransformScale } from "../../transforms/transform_scale.js";
import { TransformStraightMove } from "../../transforms/transform_straight_move.js";
import { UIImage } from "./ui_image.js";

export class TutorialCursor extends UIImage
{
  private static readonly DESIGN_W = 150;
  private static readonly ASPECT = 183 / 159;
  private static readonly PULSE_SCALE = 0.8;
  private static readonly PULSE_DURATION_MS = 650;

  constructor( ctx: CanvasRenderingContext2D )
  {
    super( ctx, 0, 0, TutorialCursor.width(), TutorialCursor.height(), ImgID.IconTutorialCursor );

    this.setClickable( false );
    this.setOpacityImmediate( 0 );
  }

  private static width(): number
  {
    return LayoutScaler.widthFromDesign( TutorialCursor.DESIGN_W );
  }

  private static height(): number
  {
    return TutorialCursor.width() * TutorialCursor.ASPECT;
  }

  public pointAt( tip: Vector2 ): void
  {
    this.stopAllTransforms();
    this.setScale( new Vector2( 1, 1 ) );
    this.setPixelPos( tip, true );
    this.showElement();
    this.startPulse( tip );
  }

  public hide(): void
  {
    this.stopAllTransforms();
    this.setScale( new Vector2( 1, 1 ) );
    this.hideElement();
  }

  private startPulse( rest: Vector2 ): void
  {
    const now = performance.now();
    const shrink = 1 - TutorialCursor.PULSE_SCALE;
    const pressed_x = rest.x - shrink * this.rect.getW2();
    const pressed_y = rest.y - shrink * this.rect.getH2();
    const pressed = new Vector2( pressed_x, pressed_y );
    const scale = new Vector2( TutorialCursor.PULSE_SCALE, TutorialCursor.PULSE_SCALE );
    const params = { easing: Easing.EaseInOutQuad, ping_pong_behaviour: true, infinite_loop: true };

    this.addTransform( new TransformScale( this, true, null, scale, now, TutorialCursor.PULSE_DURATION_MS, params ) );
    this.addTransform( new TransformStraightMove( this, true, rest.clone(), pressed, now, TutorialCursor.PULSE_DURATION_MS, params ) );
  }

  public name(): string
  {
    return "TutorialCursor";
  }
}
